import axios from "./config";
import {toast} from "react-toastify"

// Add a request interceptor
axios.interceptors.request.use(function (config) {
    //Check if auth token exists in local storage
    const token = localStorage.getItem('authToken');
    if (token) {
      config.headers['Authorization'] = 'Bearer ' + token;
    }
    return config;
  }, function (error) {
    // Do something with request error
    return Promise.reject(error);
  },
//   { synchronous: true, runWhen: () => /* This function returns true */}
);

// Add a response interceptor
axios.interceptors.response.use(function onFulfilled(response) {
    // Any status code that lie within the range of 2xx cause this function to trigger
    // Do something with response data
    return response;
  }, function onRejected(error) {
    // Any status codes that falls outside the range of 2xx cause this function to trigger
    // Do something with response error
    if(error.status>=500){
      toast.error('Server error occurred. Please try again later.');
      return Promise.reject(error);
    };

    return Promise.resolve(error.response);
});

export default axios;
